import styled from '@emotion/styled'

import {Icon} from '@vio/atlas/Icon'

// Hack to center Icon vertically with first line of text
export const TextAlignedIcon = styled(Icon)`
  display: flex;
  align-items: center;
  &::before {
    content: '.';
    display: inline-block;
    width: 0;
    visibility: hidden;
  }
`
